{
    "list_page__title": "Kampagnen",
    "list_page__empty_state_title": "Noch keine Kampagnen",
    "list_page__empty_state_description": "Bewerben Sie Artikel bei ausgewählten Kunden – Ihre Vertreter bekommen dazu Kampagnen-Aufgaben."
}
